// Local XAMPP: .env.development (/arihant_trust)
// Document-root prod: .env.production (empty basename, /api_donation/api)
// api_donation is a gateway that boots Laravel (backend)
export const API_BASE =
  process.env.REACT_APP_API_BASE || '/arihant_trust/api_donation/api';

function resolveRouterBasename() {
  const raw =
    process.env.REACT_APP_ROUTER_BASENAME !== undefined &&
    process.env.REACT_APP_ROUTER_BASENAME !== ''
      ? process.env.REACT_APP_ROUTER_BASENAME
      : process.env.PUBLIC_URL !== undefined && process.env.PUBLIC_URL !== ''
        ? process.env.PUBLIC_URL
        : process.env.NODE_ENV === 'production'
          ? ''
          : '/arihant_trust';
  // React Router: root deploy uses ""; "/" means host root and breaks matching
  if (raw === '/' || raw === '.') return '';
  return raw.replace(/\/$/, '');
}

export const ROUTER_BASENAME = resolveRouterBasename();
